import { defineStore } from "pinia";
import { getUserInfo, refreshToken } from "@/utils/api";
const useUserStore = defineStore("useUserStore", {
  state: () => ({
    info: {},
    id: "",
    nickname: "",
    lefttimes: 0,
    token: "",
    recordNum: 0,
    landPageRoute: "/", //登录前访问的页面
    areacheck: "",
  }),
  getters: {
    isLogin() {
      return !!this.token; //把token从string转为boolean类型
    },
    getToken() {
      return this.token;
    },
  },
  actions: {
    resetInfo() {
      window.localStorage.removeItem("cg_token");
      this.$reset();
    },
    setToken(token) {
      this.token = token;
      window.localStorage.setItem("cg_token", token);
      this.token_expire = Date.now() + 1000 * 60 * 60 * 18; //token 24小时后过期 这里限制到18小时
    },
    setLandPage(route) {
      this.landPageRoute = route;
    },
    async setUser() {
      const res = await getUserInfo();
      this.info = res.data;
      this.id = res.data.id;
      this.nickname = res.data.nickname;
      this.lefttimes = res.data.lefttimes;
      this.areacheck = res.data.areacheck;
    },
    reduceLeftTimes(num = 1) {
      this.lefttimes -= num;
    },
    setUserInfo(info) {
      this.info = info;
    },
    setJoinDetail(detail) {
      this.detail = detail;
    },
    setRecordNum(num) {
      this.recordNum = num;
    },
    loginOut() {
      this.resetInfo();
    },
    doShare() { }
  },
  persist: {
    enabled: true,
  },
});

export default useUserStore;
